import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createEventContactsSchemas } from 'shared/db/validation/schema/eventContacts';
import { Validator } from 'shared/db/validation/validator';
import {
    EventContactRawRecord,
    EventContactUpdateRawRecord,
} from 'shared/types/EventContact';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { EventContactDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createEventContactsSchemas();

const addValidator = createDBEntityValidator<EventContactRawRecord>(
    schemas.add,
);
const updateValidator = createDBEntityValidator<EventContactUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-event-contacts'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createEventContactsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const eventContactsInputValidation: EventContactDBValidation = {
    add: createEventContactsInputValidation(addValidator, validationStrategy),
    update: createEventContactsInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createEventContactsInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
